// Turn whole numbers into percentages
export const formatPercentage = (value) => value / 100;

// Add commas to long numbers
export const formatNumber = (num) => num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
